export default __webpack_public_path__ + "static/media/Boots of Black Oblivion.ebd50cf2.jpg";